import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

const prodUrl = '/api/authenticate';
const refreshToken = "/api/refreshtoken"
const logOut = "/api/logout"
const createUser="/api/register"
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {

  constructor(private http: HttpClient) { }



  userLogin(creds: any) {
    return this.http.post(`${prodUrl}`, creds);
  }

  setToken(token: any) {
    localStorage.setItem('token', token);
    return true;
  }




  setUserName(name: any) {
    localStorage.setItem('name', name);
    return true;
  }

  setUserType(role: any) {
    localStorage.setItem('role', role);
    return true;
  }

  isLoggedIn() {
    let token = localStorage.getItem('token');
    if (token == undefined || token == '' || token == null) {
      let refreshToken = localStorage.getItem('refreshToken')

      if (refreshToken == undefined || refreshToken == '' || refreshToken == null) {
        return false;
      }
    }
    return true;
  }

  // login(creds:any) {
  //     return this.http.post(`${this.url}`,creds);
  // }

  setUserFullName(userModel: any) {
    localStorage.setItem('userFullName', userModel);
    return true;
  }
  setUserLocationId(locationId:any){
    localStorage.setItem('userLocationId', locationId);

  }



  getUserFullName() {
    return localStorage.getItem('userFullName');
  }
  getUserLocationId(){
    return localStorage.getItem('userLocationId');
  }

  getToken() {
    return localStorage.getItem('token');
  }
  getUserName() {
    return localStorage.getItem('name');
  }
  getUserType() {
    return localStorage.getItem('role');
  }
  setUserId(userId: number) {
       localStorage.setItem('userId', userId+"");

  }
  getUserId() {
    return localStorage.getItem('userId');
  }

  refreshToken(token: string) {
    return this.http.post(`${refreshToken}`, {
      refreshToken: token
    });
  }

  public saveRefreshToken(token: string): void {
    localStorage.removeItem('refreshToken');
    localStorage.setItem('refreshToken', token);
  }

  public getRefreshToken(): string | null {
    return localStorage.getItem('refreshToken');
  }


  logout() {
    console.log("log method called ")
    let userId=this.getUserId();
    let id = {
      userId:userId
    }
    console.log("log method called "+id)

    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken')


    return this.http.post(`${logOut}`, id);

  }
  createUser(userDetails:any){

    return this.http.post(`${createUser}`,userDetails)

  }
}
